define('home/models/Feed',[
    'underscore',
    'jquery',
    'backbone',
], function (
    _,
    $,
    Backbone
) {
    'use strict';

    /**
     * A Feed. Contains the collection of items in this feed, and also manages
     * fetching the feed, maintaining whether or not there's more pages of the
     * feed, the fetching state, and whether or not there's been a fetch error.
     */
    var Feed = Backbone.Model.extend({
        // Return these from a function so that all instances don't share
        // the fetchOptions object
        defaults: function () {
            return {
                fetching: false,
                fetched: false,
                hasNext: true,
                error: false,
                items: null,
                numPages: 0,
                fetchOptions: {},

                // Deprecated
                active: false,
            };
        },

        initialize: function (_attributes, options) {
            if (!(options && (options.collectionClass || options.collection)))
                throw new Error('Feed must specify the type of collection it maintains, or pass the collection');

            var items = options.collection ||
                new options.collectionClass([], options.collectionOptions);  // eslint-disable-line new-cap

            if (items.cursor && _.has(items.cursor, 'hasNext'))
                this.set('hasNext', items.cursor.hasNext);

            if (options.collectionUrl)
                items.url = options.collectionUrl;

            this.set({ items: items }); // Deprecated, should access items as property, not attribute
            this.items = items; // New

            items.on('extend', this.onExtendComplete, this);
            items.on('sync', this.onSync, this);

            this.listenTo(items, 'all', this.propagateCollectionEvents);

            // Deprecated
            this.on('change:active', this.activeChanged, this);
        },

        propagateCollectionEvents: function () {
            var args = Array.prototype.slice.apply(arguments);
            args[0] = 'items:' + args[0];
            this.trigger.apply(this, args);
        },

        // Deprecated
        activeChanged: function () {
            if (this.get('active') && !this.get('items').length)
                this.fetchItems();
        },

        fetchItems: function (options) {
            options = options || {};

            if (!options.reset && !this.get('hasNext'))
                return $.Deferred().resolve();

            // Don't kick off request again if already fetching, unless the last
            // fetch call timed out. In that case, there isn't an active request,
            // but fetching remains set to true to continue showing the fetching
            // state while reattemting the request.
            if (this.get('fetching') && !this.get('timeouts'))
                return this.fetchPromise;

            this.set({ fetching: true });

            if (options.reset)
                this.set({ fetched: false });

            options.data = options.data || {};
            _.extend(options.data, this.get('fetchOptions'));

            var existingErr = options.error;
            var existingSuccess = options.success;
            var self = this;

            options.error = function (_collection, resp) {
                // Requests seem to hang occasionally. Should investigate. In the meantime,
                // timeout a hanging request and try it again, up to 3 times in a row.
                if (resp.statusText === 'timeout' && (self.get('timeouts') || 0) < 3) {
                    self.set({
                        timeouts: (self.get('timeouts') || 0) + 1,
                    });
                    self.fetchItems();
                    return;
                }

                self.set({
                    fetching: false,
                    error: true,
                    hasNext: false,
                    timeouts: 0,
                });

                if (existingErr)
                    existingErr.apply(this, arguments);
            };
            options.success = function () {
                self.set({
                    error: false,
                    timeouts: 0,
                    numPages: self.get('numPages') + 1,
                });

                if (existingSuccess)
                    existingSuccess.apply(this, arguments);
            };

            // If the collection of feed items is storing a cursor, it has already
            // made the initial fetch request
            var isInitialFetch = $.isEmptyObject(self.get('items').cursor) || options.reset;

            this.fetchPromise = self.get('items')[isInitialFetch ? 'fetch' : 'more'](options);
            return this.fetchPromise;
        },

        // Called on sync event. This is when the collection is synced with the
        // server, either fetched or saved
        onSync: function (_items, response) {
            this.set({
                fetched: true,
                fetching: false,
                hasNext: response.cursor && response.cursor.hasNext,
            });
        },

        ensureFetched: function () {
            if (!this.get('fetched') && !this.get('fetching') && !this.fetchPromise)
                this.fetchItems({ reset: true });

            return this.fetchPromise ? this.fetchPromise : $.Deferred().resolve();
        },

        // Called on extend event. This is when the recently fetched items have
        // been subsidized with data from embedly.
        onExtendComplete: function (hasNext) {
            this.set({
                hasNext: hasNext,
            });
        },
    });

    return Feed;
});

